import React,{useEffect, useState} from 'react';
import styles from "../../../assets/styles/modules/Newsinfo.module.css";
import icon from "../../../assets/images/icon_black.svg";
import {Button} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {useNavigate} from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import {addMycorpAPI, checkMycorpAPI, delMycorpAPI} from "../../../apis/my_service";
import toast from "react-hot-toast";

const StockInfoCard = ({news, curate}) => {
    const navigate = useNavigate()
    const moveToStock = () => navigate(`/stock/${news.stockcode}`)

    const [isSubscribe, setIsSubscribe] = useState(null) // 종목 구독 여부 체크

    const notify = (msg, type) => {
        if(type === 'success') return toast.success(msg)
        else if (type === 'error') return toast.error(msg)
        else return toast(msg)
    };

    const checkSubscribe = () => {
        checkMycorpAPI(news.stockcode).then(res => setIsSubscribe(res))
    }

    const subscribeBtnClick = (stockcode,stockname) => {
        if(isSubscribe === true){
            delMycorpAPI(stockcode).then(() => {
                notify('마이기업 삭제가\n 완료 되었습니다.','success')
                setIsSubscribe(false)
            })
        }else if(isSubscribe === false) {
            addMycorpAPI(stockcode).then((res) => {
                if(res){
                    setIsSubscribe(true)
                    notify(stockname + ' 이/가 마이기업으로\n등록 되었습니다.\nAI 콴의 다양한 뉴스 분석 콘텐츠를\n 확인해보세요!', 'success')
                } else {
                    notify(stockname + ' 이/가 이미 존재합니다!', 'error')
                }
            })
        } else {
            notify('로그인이 필요합니다.', 'error')
        }
    }

    useEffect(checkSubscribe, [isSubscribe])


    return (
        <div className={styles.corp_container}>
            <div className={styles.corp_header}>
                <img src={icon} alt="corpImage"/>
                <div className={styles.corp_info}>
                    <p className={styles.stockname}>{news.stockname}</p>
                    <Button
                        variant='outlined' startIcon={<AddIcon/>}
                        sx={{
                            height: '28px', borderRadius: '23px', padding:'8px 6px',
                            border: isSubscribe ? 'none':'solid 1px #e63d44',
                            color: isSubscribe ? '#fff' : '#e63d44',
                            backgroundColor: isSubscribe ? '#e63d44':'#fff',
                            '&:hover':{
                                border: isSubscribe ? 'none':'solid 1px #e63d44',
                                color: isSubscribe ? '#fff' : '#e63d44',
                                backgroundColor: isSubscribe ? '#e63d44':'#fff',
                            },
                            '&:focus':{
                                border: isSubscribe ? 'none':'solid 1px #e63d44',
                                color: isSubscribe ? '#fff' : '#e63d44',
                                backgroundColor: isSubscribe ? '#e63d44':'#fff',
                            },
                            '& span': {marginRight: 0}
                        }}
                        onClick={()=>subscribeBtnClick(news.stockcode,news.stockname)}>
                        <span >구독</span>
                    </Button>
                    <p>
                        <span className={styles.price}>{news.stockquotes.toLocaleString("ko-KR")}</span>
                        <span className={`${styles.percent} ${news.gappercent > 0 ? styles.positive : styles.negative}`}>{news.gappercent > 0 ? '▲' : '▼'} {news.gappercent}</span>
                    </p>
                </div>
                <Button variant='outlined' endIcon={<ArrowForwardIcon sx={{color:'#999'}} className={styles.arrow_icon}/>}
                        onClick={moveToStock}
                        className={styles.show_stock_btn}
                        sx={{
                            right: 0, height: '46px', borderRadius: '23px', border: 'solid 1px #eee', color: '#222',
                            '&:hover':{
                                border: 'solid 1px #eee',
                                backgroundColor: '#f7f7f9'
                            },
                            '&:focus':{
                                border: 'solid 1px #eee'
                            }
                        }}>
                    <span className={styles.show_stock_txt}>종목 보러가기</span>
                </Button>
            </div>
            <div className={styles.corp_curate}>
                <p>{curate && Object.values(curate)}</p>
            </div>
        </div>
    );
};

export default StockInfoCard;